import { Check, Circle } from 'lucide-react';
import { evaluatePasswordCriteria } from '../utils/passwordCriteria';

interface PasswordCriteriaListProps {
  password: string;
  confirmPassword?: string;
  showMatch?: boolean;
  /** Use dark-only colors when forced; adaptive follows the app theme. */
  tone?: 'dark' | 'adaptive';
}

export default function PasswordCriteriaList({
  password,
  confirmPassword,
  showMatch = false,
  tone = 'adaptive',
}: PasswordCriteriaListProps) {
  const checks = evaluatePasswordCriteria(password);
  const matchMet = Boolean(password) && Boolean(confirmPassword) && password === confirmPassword;
  const rows = showMatch
    ? [...checks, { id: 'match', label: 'Passwords match', met: matchMet }]
    : checks;

  const unmetClass = tone === 'dark'
    ? 'text-zinc-500'
    : 'text-zinc-500 dark:text-zinc-400';
  const metClass = tone === 'dark'
    ? 'text-cyan-400'
    : 'text-cyan-600 dark:text-cyan-400';

  return (
    <ul className="space-y-1.5" aria-live="polite">
      {rows.map((row) => (
        <li key={row.id} className={`flex items-center gap-2 text-xs ${row.met ? metClass : unmetClass}`}>
          {row.met ? (
            <Check className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          ) : (
            <Circle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          )}
          <span>{row.label}</span>
        </li>
      ))}
    </ul>
  );
}
